import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SplashscreenService } from 'src/app/shared/services/splashscreen.service';

@Injectable()
export class SavedSearchesDataService {
  constructor(
    private readonly http: HttpClient,
    private readonly splashscreenService: SplashscreenService
  ) { }

  getSavedSearches(): Observable<any[]> {
    return this.http.get<any[]>('/api/savedsearchlistitems').pipe(
      tap({
        next: () => this.splashscreenService.notifyFirstWidgetDataLoaded(),
        error: () => this.splashscreenService.notifyFirstWidgetDataLoaded()
      })
    );
  }

  deleteSavedSearch(guid: string): Observable<void> {
    return this.http.delete<void>(`/api/savedsearches/${encodeURIComponent(guid)}`);
  }

  renameSavedSearch(value: string, item: any): Observable<any> {
    return this.http.put(`/api/savedsearchlistitems/${encodeURIComponent(value)}`, item);
  }
}
